/**
 * Platform_Locations_Service.ts
 * The org's platform location(s) (identity.locations — SSOT), referenced
 * through the adapter's /locations/platform sync endpoint (not fetched from
 * skplatform-api directly — see api/endpoints.ts). This both returns the
 * list AND references each into the adapter's own hosp_location cache, so
 * "Create venue" always has a real, already-persisted locationId to use.
 */

import { apiClient } from '../../api/axiosInstance';
import { Hosp_Locations_Platform_Url } from '../../api/endpoints';
import type { Location } from '../../schemas/config/location';

export interface SyncedPlatformLocation extends Location {
  isPrimary: boolean;
}

/** This org's locations, already referenced into hosp_location. */
export const syncPlatformLocations = async (): Promise<SyncedPlatformLocation[]> => {
  const { data } = await apiClient.get<SyncedPlatformLocation[]>(Hosp_Locations_Platform_Url);
  return data ?? [];
};
